export default "__VITE_ASSET__toeq9r34__"